import appConfig from 'configs/app.config'

/**
 * Home path for an authenticated web user based on authority.
 * Managers must not be sent to the admin /dashboard (that triggers AccessDenied).
 */
export function getAuthenticatedEntryPath(userAuthority = []) {
	const authority = Array.isArray(userAuthority) ? userAuthority : []

	if (authority.includes('admin')) {
		return '/dashboard'
	}
	if (authority.includes('manager')) {
		return '/manager-dashboard'
	}
	if (authority.includes('user')) {
		return '/access-denied'
	}

	return appConfig.authenticatedEntryPath
}

export default getAuthenticatedEntryPath
